var render = function () {
  var _vm$list, _vm$columns;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-component border border-grey-field rounded-lg overflow-x-auto",
    class: {
      compact: _vm.compact
    }
  }, [_c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "w-full border-collapse rounded-lg overflow-hidden"
  }, [_c('thead', {}, [_c('tr', _vm._l(_vm.columns, function (column, index) {
    return _c('td', {
      key: 'columns-' + index,
      staticClass: "whitespace-nowrap font-bold",
      class: [column.position ? "text-".concat(column.position) : 'text-left']
    }, [_vm._v(" " + _vm._s(column.label) + " "), _c('span')]);
  }), 0)]), _c('tbody', [((_vm$list = _vm.list) === null || _vm$list === void 0 ? void 0 : _vm$list.length) > 0 ? _vm._l(_vm.list, function (entry, idx) {
    return _c('tr', {
      key: 'entry-' + idx
    }, _vm._l(_vm.columns, function (column, index) {
      return _c('td', {
        key: 'columns-' + index,
        staticClass: "align-middle leading-5"
      }, [_vm._t("table-row", null, {
        "entry": entry,
        "column": column,
        "index": idx
      })], 2);
    }), 0);
  }) : [_c('tr', [_c('td', {
    staticClass: "text-center empty",
    attrs: {
      "colspan": (_vm$columns = _vm.columns) === null || _vm$columns === void 0 ? void 0 : _vm$columns.length
    }
  }, [_c('div', {
    staticClass: "flex justify-center items-center w-full flex-col gap-2"
  }, [_c('Empty', {
    attrs: {
      "width": "48",
      "height": "48"
    }
  }), _c('p', {}, [_vm._v(_vm._s(_vm.emptyMessage))])], 1)])])]], 2)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }